import { render } from "./FeaturesStrip.vue?vue&type=template&id=19eec1d2&scoped=true"
import script from "./FeaturesStrip.vue?vue&type=script&lang=js"
export * from "./FeaturesStrip.vue?vue&type=script&lang=js"

import "./FeaturesStrip.vue?vue&type=style&index=0&id=19eec1d2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19eec1d2"]])

export default __exports__